/** @format */
// Errors
export const ERROR = "ERROR";

// Pokemon's
export const GET_POKEMONS = "GET_POKEMONS";
export const GET_POKEMON = "GET_POKEMON";
export const SET_LOADING_POKEMON = "SET_LOADING_POKEMON";

//Moves
export const GET_MOVES = "GET_MOVES";
export const SET_LOADING_MOVES = "SET_LOADING_MOVES";

// Liked (Local Storage)
export const GET_LIKED = "GET_LIKED";
export const ADD_LIKED = "ADD_LIKED";
export const REMOVE_LIKED = "REMOVE_LIKED";
